import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Church staff work in long-lived tabs; refetching every window focus
      // hammers the API for data that rarely changes minute to minute.
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Never retry an answer that won't change — signed out, not allowed,
        // not there, not valid — retrying only delays saying so.
        const status = (error as { status?: number }).status
        if (status !== undefined && [400, 401, 403, 404, 422].includes(status)) return false
        return failureCount < 2
      },
    },
  },
})
